import React from "react";
import SiteFooter, { DEFAULT_GROUPS, DEFAULT_LEGAL } from "../../Components/SiteFooter";

/**
 * The marketing pages' footer. A thin wrapper over SiteFooter that keeps
 * this component's props: a landing page can pass its own menus (/partner
 * passes the sections of its page) and `light` for a dark background.
 */
const Footer = ({ windowSize, light = false, menuItems1, menuItems2, menuItems3, defaultPath = "/" }) => {
  const groups = menuItems1 || menuItems2
    ? [
        menuItems1 && { title: "Explore", items: menuItems1 },
        menuItems2 && { title: "Get started", items: menuItems2 },
      ].filter(Boolean)
    : DEFAULT_GROUPS;

  return (
    <SiteFooter
      groups={groups}
      legal={menuItems3 || DEFAULT_LEGAL}
      light={light}
      logoSrc={light ? require("../../assets/eVerbary Logo_Text_Inverted 1.png") : undefined}
      defaultPath={defaultPath}
    />
  );
};

export default Footer;
